import { OrganizerAutocompleteExperiment } from '@/types/experiments';
import { normalizeModuleDefault } from '@eventbrite/legacy-infra.transformation-utils';
import { isStatsigInitialized } from '@eventbrite/legacy-infra.statsig';
import statsigModule from 'statsig-js';
const statsig = normalizeModuleDefault(statsigModule);

export const getOrganizerAutocompleteExperiment = () => {
    if (!isStatsigInitialized()) {
        return {
            value: OrganizerAutocompleteExperiment.values.control,
        };
    }

    const config = statsig.getExperimentWithExposureLoggingDisabled(
        OrganizerAutocompleteExperiment.name,
    );

    return {
        value: config.get(
            OrganizerAutocompleteExperiment.paramName,
            OrganizerAutocompleteExperiment.values.control,
        ),
    };
};

export const manuallyLogOrganizerAutocompleteExperiment = () => {
    if (isStatsigInitialized()) {
        statsig.manuallyLogExperimentExposure(OrganizerAutocompleteExperiment.name, false);
    }
};
